import Close from '@svg/close';
import Image from "next/legacy/image";
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { isAndroid } from "react-device-detect";
import getConfig from "next/config";
import { useAppContext } from '@context/app';
const { publicRuntimeConfig } = getConfig();

interface Props {
  setIsBanner: (value: boolean) => void
}
const SmartAppBanner: React.FC<Props> = ({ setIsBanner }) => {
  const [showBanner, setShowBanner] = useState(false);
  const { country } = useAppContext()
  const { pathname, query } = useRouter()
  const shareLink = publicRuntimeConfig.ANDROID_SHARE_URL

  useEffect(() => {
    const lastClosedTimestamp = localStorage.getItem('smartAppBannerLastClosed');
    if (lastClosedTimestamp) {
      const daysSinceLastClose = (Date.now() - parseInt(lastClosedTimestamp)) / (1000 * 60 * 60 * 24);
      if (daysSinceLastClose < 90) {
        setIsBanner(false)
        return;
      }
    }
    if (isAndroid) {
      setIsBanner(true)
      setShowBanner(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const closeBanner = () => {
    setShowBanner(false);
    setIsBanner(false)

    localStorage.setItem('smartAppBannerLastClosed', Date.now() as any);
  };



  const openAppOrRedirectToStore = () => {
    const testUrl = pathname === "/product/[slug]" ? `${shareLink}${country?.code2 || "KW"}/product/${query.slug}` : shareLink
    const anchor = document.createElement('a');
    anchor.href = testUrl;
    anchor.style.display = 'none';
    document.body.appendChild(anchor);
    const openAppScheme = () => {
      anchor.click();
    };

    openAppScheme();
  };


  if (!showBanner) {
    return null;
  }

  return (
    <div className='sticky_position flex justify-center items-center bg-[#3b3b3b] text-white p-2  w-full z-[1000]'>
      <div className=' flex items-center justify-between w-full' >
        <button onClick={closeBanner} aria-label='Close Banner'>
          <Close className='w-5 h-5 border rounded-full p-1 cursor-pointer' />
        </button>
        <div className=' flex items-center flex-1 px-3'>
          <div className='w-10 h-10 relative'>
            <Image
              src="/dabdoob.webp"
              layout="fill"
              objectFit={"fill"}
              alt="dabdoob"
              loading='lazy'
              sizes='100vw'
            />
          </div>
          <div className=' px-2'>
            <p className=' text-white font-bold text-sm mb-1'>Dabdoob</p>
            <p className=' text-white text-xs'>FREE - In Google Play</p>
          </div>
        </div>
        <button className=' mx-1 p-1 px-2 bg-brandBlue rounded-lg text-sm font-normal  text-white' onClick={() => openAppOrRedirectToStore()}>
          View
        </button>
      </div>
    </div>
  );
};

export default SmartAppBanner;



